module.exports = __webpack_public_path__ + "img/battery-full.34986304.svg";